export * from "-!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./StoryCard.vue?vue&type=template&id=1ca37313&"


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/base/stories/StoryCard.vue?vue&type=template&id=1ca37313&
// module id = 895
// module chunks = 0